import { render, staticRenderFns } from "./EditShippingInfo.vue?vue&type=template&id=68a18f6d&scoped=true"
import script from "./EditShippingInfo.vue?vue&type=script&lang=js"
export * from "./EditShippingInfo.vue?vue&type=script&lang=js"
import style0 from "./EditShippingInfo.vue?vue&type=style&index=0&id=68a18f6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a18f6d",
  null
  
)

export default component.exports